module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BookItalic.c38dba0b.ttf";